import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    deleteBooking,
    toggleShowUnitBookingMenuBox,
    toggleShowDeleteBoxThunk,
    toggleShowEditBoxThunk
} from '../../store/ResourceStore';
import './UnitBookingMenu.css';

const UnitBookingMenu = ({ p }) => {
    const resState = useSelector(state => state.resourceState);
    const dispatch = useDispatch();

    const toggleUnitBookingMenuBox = () => {
        dispatch(toggleShowUnitBookingMenuBox(p));
    };
    const toggleDeleteBox = () => {
        dispatch(toggleShowDeleteBoxThunk(p));
    };
    const toggleEditBox = () => {
        dispatch(toggleShowEditBoxThunk(p));
    };

    if (!resState.showUnitBookingMenuBox || resState.bookingIdToUnitBookingMenu !== p.id) {
        return null;
    }

    let who = "";
    if (p.person !== null && p.person !== undefined) {
        who = p.person.name.trim().split(/\s+/)[0];
    } else {
        who = p.team.name;
    }

    if (resState.showDeleteBox || resState.bookingIdToDelete === p.id) {
        return (
            <div className="delete-box">
                <div className="background"></div>
                <div className="text-wrapper">
                    Bekræft at du vil slette {who}'s booking af {p.unit.name}
                </div>
                <button className="confirm-delete-button" onClick={() => dispatch(deleteBooking(p.id))}>Bekræft sletning</button>
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-x-circle-fill close" viewBox="0 0 16 16" onClick={(event) => { event.stopPropagation(); toggleDeleteBox(); }}>
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                </svg>
            </div>
        );
    }

    return (
        <div className="unit-booking-menu-box">
            <div className="background"></div>
            <div className="text-wrapper">
                Vil du slette eller ændre {who}'s booking af {p.unit.name}?
            </div>
            <div className='unit-booking-menu-buttons'>
                <button className="unit-booking-delete-button" onClick={toggleDeleteBox}>Slet</button>
                <button className="unit-booking-edit-button" onClick={toggleEditBox}>Ændre tidspunkt</button>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-x-circle-fill close" viewBox="0 0 16 16" onClick={(event) => { event.stopPropagation(); toggleUnitBookingMenuBox(); }}>
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
            </svg>
        </div>
    );
};

export default UnitBookingMenu;